import { ErrorFlash } from '@dtna/dvs-core-dcp-ui-libraries';
import '../assets/modal.scss';

export default function FatalErrorModal() {
  return (
    <ErrorFlash className="aligner margin-horizontal--large font-weight--bold height--100-percent" />
  );
}
